module.exports = __webpack_public_path__ + "static/media/ApproveCards.a3e6ebdb.svg";